<template>
  <ul
    v-if="formattedSeasonalWeather.length"
    class="grid grid-cols-2 lg:grid-cols-4 gap-4 list-none p-0 m-0"
   
  >
    <li
      v-for="entry in formattedSeasonalWeather"
      :key="entry.Season ?? entry.Months ?? ''"
      class="rounded-2xl border border-gray-100 bg-white p-4 space-y-3"
      :data-season="entry.Season"
    >
      <div class="flex items-center gap-2">
        <TIcon
          :icon="['fal', seasonIcon(entry.Season)]"
          size="sm"
          class="text-secondary"
        />
        <span class="text-sm font-semibold capitalize">
          {{ entry.Season }}
        </span>
      </div>

      <p
        v-if="entry.Months"
        class="text-xs text-gray-500"
      >
        {{ entry.Months }}
      </p>

      <div class="flex gap-4 text-sm">
        <span
          v-if="useCelsius"
          class="font-medium"
        >
          {{ entry.AvgHighC }}° / {{ entry.AvgLowC }}°C
        </span>
        <span
          v-else
          class="font-medium"
        >
          {{ entry.AvgHighF }}° / {{ entry.AvgLowF }}°F
        </span>
        <span class="text-gray-500">
          {{ entry.PrecipMm }} mm
        </span>
      </div>

      <p
        v-if="entry.Summary"
        class="text-xs text-gray-600 leading-snug"
      >
        {{ entry.Summary }}
      </p>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { IconName } from '@fortawesome/fontawesome-svg-core'
import type { PoiWeatherEntry } from '~/types/rental-api-aliases'

const props = defineProps<{
  seasonalWeather: PoiWeatherEntry[]
  useCelsius: boolean
}>()

const SEASON_ORDER: Record<string, number> = { spring: 0, summer: 1, fall: 2, winter: 3 }

const formattedSeasonalWeather = computed<PoiWeatherEntry[]>(() => {
  const raw = props.seasonalWeather
  if (!raw?.length) return []
  return [...raw].sort((a, b) => {
    const aIdx = SEASON_ORDER[a.Season?.toLowerCase() ?? ''] ?? 99
    const bIdx = SEASON_ORDER[b.Season?.toLowerCase() ?? ''] ?? 99
    return aIdx - bIdx
  })
})

function seasonIcon(season: Nullable<string> | undefined): IconName {
  switch (season?.toLowerCase()) {
    case 'spring': return 'seedling'
    case 'summer': return 'sun'
    case 'fall': return 'leaf'
    case 'winter': return 'snowflake'
    default: return 'cloud-sun'
  }
}
</script>
